import Rails from '@rails/ujs';
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");

Rails.start();
ReactRailsUJS.useContext(componentRequireContext);